/**
 * "Dashboard" documentation section (ADR-0074).
 * The admin app at app.<domain>. Ordered as a build → test → operate → govern →
 * settings flow: overview, the agent-building surfaces (catalog, governance,
 * endpoints, external MCP, prompts, knowledge, design), the playground to test
 * it, then the operate/observe surfaces (conversation & usage logs, monitoring,
 * audit), the LIMITS group, and finally environments, team, and settings.
 */
import { DASHBOARD_ALLOWED_SITES_PAGE } from './pages/dashboard-allowed-sites.page';
import { DASHBOARD_ANALYTICS_PAGE } from './pages/dashboard-analytics.page';
import { DASHBOARD_AUDIT_PAGE } from './pages/dashboard-audit.page';
import { DASHBOARD_BYOMCP_PAGE } from './pages/dashboard-byomcp.page';
import { DASHBOARD_CATALOG_PAGE } from './pages/dashboard-catalog.page';
import { DASHBOARD_COMPLIANCE_PAGE } from './pages/dashboard-compliance.page';
import { DASHBOARD_CONNECTIONS_PAGE } from './pages/dashboard-connections.page';
import { DASHBOARD_CONVERSATION_LOGS_PAGE } from './pages/dashboard-conversation-logs.page';
import { DASHBOARD_DESIGN_PAGE } from './pages/dashboard-design.page';
import { DASHBOARD_ENDPOINTS_PAGE } from './pages/dashboard-endpoints.page';
import { DASHBOARD_ENVIRONMENTS_PAGE } from './pages/dashboard-environments.page';
import { DASHBOARD_EXPERIENCE_PAGE } from './pages/dashboard-experience.page';
import { DASHBOARD_GOVERNANCE_PAGE } from './pages/dashboard-governance.page';
import { DASHBOARD_KNOWLEDGE_PAGE } from './pages/dashboard-knowledge.page';
import { DASHBOARD_LABS_PAGE } from './pages/dashboard-labs.page';
import { DASHBOARD_LIMITS_PAGE } from './pages/dashboard-limits.page';
import { DASHBOARD_MONITORING_PAGE } from './pages/dashboard-monitoring.page';
import { DASHBOARD_OVERVIEW_PAGE } from './pages/dashboard-overview.page';
import { DASHBOARD_PAGE_RULES_PAGE } from './pages/dashboard-page-rules.page';
import { DASHBOARD_PLAYGROUND_PAGE } from './pages/dashboard-playground.page';
import { DASHBOARD_PROACTIVE_PAGE } from './pages/dashboard-proactive.page';
import { DASHBOARD_PROMPTS_PAGE } from './pages/dashboard-prompts.page';
import { DASHBOARD_SETTINGS_PAGE } from './pages/dashboard-settings.page';
import { DASHBOARD_SITE_MAPPING_PAGE } from './pages/dashboard-site-mapping.page';
import { DASHBOARD_STARTERS_PAGE } from './pages/dashboard-starters.page';
import { DASHBOARD_TEAM_PAGE } from './pages/dashboard-team.page';
import { DASHBOARD_USERS_PAGE } from './pages/dashboard-users.page';

import type { DocSection } from './types';

export const DASHBOARD_SECTION: DocSection = {
  id: 'dashboard',
  titleKey: 'docs.section.dashboard.title',
  pages: [
    DASHBOARD_OVERVIEW_PAGE,
    // Build: what the agent can do, and where the proposals come from.
    DASHBOARD_CATALOG_PAGE,
    DASHBOARD_SITE_MAPPING_PAGE,
    DASHBOARD_GOVERNANCE_PAGE,
    DASHBOARD_ENDPOINTS_PAGE,
    DASHBOARD_BYOMCP_PAGE,
    DASHBOARD_CONNECTIONS_PAGE,
    DASHBOARD_ALLOWED_SITES_PAGE,
    // Shape: how it sounds, what a visitor meets, and how an answer is built.
    DASHBOARD_PROMPTS_PAGE,
    DASHBOARD_KNOWLEDGE_PAGE,
    DASHBOARD_DESIGN_PAGE,
    DASHBOARD_STARTERS_PAGE,
    DASHBOARD_PROACTIVE_PAGE,
    DASHBOARD_EXPERIENCE_PAGE,
    DASHBOARD_PAGE_RULES_PAGE,
    DASHBOARD_PLAYGROUND_PAGE,
    // Operate: what happened, to whom, and whether it was any good.
    DASHBOARD_CONVERSATION_LOGS_PAGE,
    DASHBOARD_MONITORING_PAGE,
    DASHBOARD_ANALYTICS_PAGE,
    DASHBOARD_USERS_PAGE,
    DASHBOARD_COMPLIANCE_PAGE,
    DASHBOARD_AUDIT_PAGE,
    // Govern: limits, promotion, people, settings.
    DASHBOARD_LIMITS_PAGE,
    DASHBOARD_ENVIRONMENTS_PAGE,
    DASHBOARD_TEAM_PAGE,
    DASHBOARD_SETTINGS_PAGE,
    DASHBOARD_LABS_PAGE,
  ],
};
